// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"GrantPage_Wrapper__Y1oq7","Grants":"GrantPage_Grants__bdgr_"};